<template>
  <div
	  v-if="risultatoSimulazione"
	  class="body">

		<header>
			<div>
				<img alt="logo" src="https://app.simulatoreclickday.it/img/LogoInail.png">
			</div>
		</header>

		<div class="main">
			<div class="domanda_inviata_con_successo">
				Domanda inviata con successo
			</div>
			<div class="titolo">
				<span>{{ risultatoSimulazione.nomeGameday }}</span>
				<span> - Convalida Domanda</span>
			</div>

			<div style="padding-left:5px">
				<div class="form-gray py-10">
					<template v-if="risultatoSimulazione.hasError">
						<div class="mb-2" :style="`font-weight: 500; color: ${scdRed}`">{{ risultatoSimulazione.message }}</div>
					</template>
					<template v-else>
						<div class="mb-2" style="font-weight: 500">La domanda è stata inserita correttamente. Il tuo tempo è {{ risultatoSimulazione.tempoImpiegato }}</div>
						<div style="font-weight: 500">Cliccare sul pulsante ESCI per uscire</div>
						<input
							@click="goBack()"
							type="button"
							value="Esci"
							title="Esci"
							class="btn mt-12"
						>
					</template>

				</div>
			</div>
		</div>

		<footer>
			2022 INAIL - ISTITUTO NAZIONALE PER L'ASSICURAZIONE CONTRO GLI INFORTUNI SUL LAVORO
		</footer>
  </div>
	
	<div v-else class="ma-7">
		<div class="text-h2 font-weight-bold">
			Hai già visualizzato la schermata di esito.<br>
			Non è possibile farlo una seconda volta.
		</div>
		<input
			@click="goBack()"
			type="button"
			value="Esci"
			title="Esci"
			class="btn mt-12"
		>
	</div>
</template>

<script>
export default {
  data() {
    return {
      alertType: null,

			gameDayId: null,

      risultatoSimulazione: {
        // DATI IN ARRIVO DAL LOCAL STORAGE
				nomeGameday: null,
				tempoImpiegato: null,
				hasError: false,
				message: null,
        colore: null
      },
      // message: null,

      snackbar: {
        showSnackbar: false,
        message: null,
        alertType: null,
      }
    };
  },

  created() {
		this.gameDayId = window.__GAMEDAY_ID__;
	  
	  // let nonHoPremutoF5 = localStorage.getItem('nonHoPremutoF5');
	  // if (nonHoPremutoF5 === null) {
		//   localStorage.setItem('nonHoPremutoF5', 'true')
	  // }
	  // else {
		//   localStorage.removeItem(`risultatoSimulazioneGameDay${this.gameDayId}`);
	  // }
		
	  axios.get(`/clickdayit/risultato-simulazione-gameday/${this.gameDayId}`)
		  .then(response => {
			  this.risultatoSimulazione = response.data;
			  // console.log(this.risultatoSimulazione);
		  })
	  
    // this.risultatoSimulazione = JSON.parse(localStorage.getItem(`risultatoSimulazioneGameDay${this.gameDayId}`));
	  
  },

  methods: {
    goBack: function() {
			window.location.href = '/home#/gaming-game-day'
    },
  }
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap');

.body {
	min-width: 489.1px;
	max-width: 1366px;
	width: auto;
	font-family: 'Open Sans', sans-serif;
	font-size: 14.4333px;
	background-color: white;
}
footer {
	//position: absolute;
	//bottom: 0;
	//left: 0;
	width: 100%;
	background-color: #002e5f;
	padding: 20px 60px 20px;
	color: #fff;
	font-size: .9em;
}
#logo-inail {
	margin-left: 60px;
	margin-bottom: 40px;
	display: block;
	width: 176px;
	height: 56px;
}
#logo-inail img {
	width: 176px;
}
h1 {
	display: none
}
h2 {
	margin-top: 0;
}
h3 {
	margin: 0;
	margin-bottom: 30px;
	text-transform: uppercase;
	font-weight: 400;
	font-size: 16.5px;
}
h4 {
	font-size: 1.25em;
	margin-top: 10px;
	margin-bottom: 25px;
	font-weight: 500;
	line-height: 1.1;
}
fieldset {
	margin: 0;
	padding: 0;
	border: 0;
}
p {
	margin-bottom: 10px;
}
header {
	padding: 60px 60px 40px 60px;
	border-bottom: 20px solid #002e5f;
}
.main {
	border-top: 20px solid #1E6665;
	padding: 30px;
}
.main h2 {
	color: #002e5f;
	margin-bottom: 30px;
	font-family: 'Open Sans semibold', sans-serif;
	font-size: 23.8333px;
	font-weight: 500;
}
.mr-15 {
	margin-right: 15px;
}
.form-gray {
	background-color: #f2f2f2;
	padding: 35px 30px;
}
.form-elem {

	margin-bottom: 20px;
}
.form-elem .msg {
	position: relative;
	top: 5px;
	display: none;
}
.form-elem input:not([type="checkbox"]), form-elem label input:not([type="radio"]), .form-elem select {
	width: 100%;
	border: 1px solid #afafaf;
	background-color: #fff;
	height: 34px;
	box-sizing: border-box;
	padding: 6px 12px;
}
.form-elem input:focus, .form-elem select:focus {
	outline: 0;
	border-color: #66afe9;
	box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6);
}
.form-elem label {
	margin-bottom: 5px;
	display: inline-block;
}
.form-elem.errore .msg {
	display: block;
}
.form-elem.errore input:focus, .form-elem.errore select:focus {
	box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #ce8483;
}
.form-elem.errore input, .form-elem.errore select {
	border-color: #ff5252 ;
	/* border-color: #C9291B; */
}
.form-elem.errore label, .testo-errore {
	color: #ff5252 ;
	/* color: #C9291B; */
}
.form-elem.date-elem label{
	display: block;
}
.form-elem.date-elem input{
	width: 200px;
}
.btn {
	background-color: #002e5f;
	color: #fff;
	text-transform: uppercase;
	border-radius: 0;
	border: 0;
	min-width: 160px;
	font-weight: 400;
	padding: 6px 12px;
	line-height: 1.92857em;
	cursor: pointer;
	&.abbandona {
		background-color: #bc2025;
	}
	&.dati-personali {
		background-color: #e6901c;
	}
}
.btn-row {
	height: 40px;
	margin-top: 40px;
}
.btn[disabled] {
	pointer-events: none;
	cursor: not-allowed;
	box-shadow: none;
	background: #d2d2d2;
	border-color: #d2d2d2;
	color: #002e5f;
	opacity: 1 !important;
}

.btn:focus, input[type=checkbox]:focus, .feedback:focus {
	outline: thin dotted;
	outline-offset: -2px;
}
input[type=checkbox] {
	margin: 0;
	margin-right: 5px;
	top: 3px;
	position: relative;
}
.pull-right {
	float: right;
}
.xs-12 {
	width: 100%;
}

.domanda_inviata_con_successo {
	background-color: green;
	color: white;
	padding: 10px 30px;
}

.titolo {
	margin-top: 15px;
	margin-bottom: 25px;
	font-weight: 700;
	font-size: 24px;
	color: #002e5f;
}

::v-deep ._radio_group label,
::v-deep ._checkbox label {
	animation: none !important;
}

/*SM*/
@media (min-width: 768px) {}
/*MD*/
@media (min-width: 992px) {
	.md-3 {
		width: 25%;
	}
	.md-6 {
		// width: 50%;
		width: 100%;
	}
}

/*LG*/
@media (min-width: 1200px) {}
.loader-overlay {
	position: fixed;
	background-color: #002E5F;
	background-color: rgba(0, 46, 95, 0.2);
	width:100%;
	height:100%;
	top:0;
	left: 0;
	opacity: 1;
	z-index: 500000;
}
.loader-overlay span{
	position: fixed; /* or absolute */
	top: 50%;
	left: 50%;
	border: 10px solid #106CDB; /* Light grey */
	border-top: 10px solid #002e5f; /* Blue */
	border-radius: 50%;
	width: 60px;
	height: 60px;
	animation: spin 2s linear infinite;
}
@keyframes spin {
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
}
.data-summary strong {
	width: 200px;
	display: inline-block;
}

.avviso-finale-prova {
	position: absolute;
	bottom: 200px;
	left: 50%;
	transform: translate(-50%, -50%);
}
.page-overlay {
	position: absolute;
	top:0;
	right:0;
	bottom:0;
	left:0;
	background-color: rgba(0, 0, 0, 0.50);
}

.tour-2-3 {
	width: 100%;
}
@media (min-width: 992px) {
	.tour-2-3 {
		width: 50%;;
	}
}

.ok-button-wrapper {
	display: flex;
	justify-content: flex-end;
	padding-top: 20px;
}
.ok-button {
	color: #002e5f;
	font-size: 20px;
	text-decoration: none;
	padding: 5px 10px;
	background-color: white;
	border-radius: 3px;
}
</style>